import { Observable } from 'rxjs';

export declare type Field = TextField | IconButtonField;

export interface FieldType {
  type: 'text' | 'btn';
  sticky?: boolean;
  stickyEnd?: boolean;
  sortable?: boolean;
}

export interface FieldConfigExtras {
  sticky?: boolean;
  stickyEnd?: boolean;
  sortable?: boolean;
}

export class TextField implements FieldType {

  public dataGenerator?: (item: any) => string;

  public type: FieldType['type'] = 'text';
  public sticky?: boolean;
  public stickyEnd?: boolean;
  public sortable?: boolean;

  constructor(public name: string,
              public title: Observable<string>,
              dataGenerator?: (item: any) => string,
              extras?: FieldConfigExtras) {
    this.dataGenerator = typeof dataGenerator === 'function' ? dataGenerator : this.defaultGenerator;
    if (extras) {
      this.sticky = extras.sticky;
      this.stickyEnd = extras.stickyEnd;
      this.sortable = extras.sortable;
    }
  }

  private defaultGenerator(item: any): string {
    return String(item);
  }
}

export class IconButtonField implements FieldType {

  public type: FieldType['type'] = 'btn';
  public clickHandler?: (item: any, evt: Event) => void;

  public sticky?: boolean;
  public stickyEnd?: boolean;
  public sortable?: boolean;

  constructor(public name: string,
              public title: Observable<string>,
              public iconName: string,
              public color?: string,
              clickHandler?: (item: any, evt: Event) => void,
              extras?: FieldConfigExtras) {
    this.clickHandler = typeof clickHandler === 'function' ? clickHandler : this.defaultClickHandler;
    if (extras) {
      this.sticky = extras.sticky;
      this.stickyEnd = extras.stickyEnd;
      this.sortable = extras.sortable;
    }
  }

  private defaultClickHandler(item: any, evt: Event) {
    evt.preventDefault();
  }

}

export class EditButtonField extends IconButtonField {
  constructor(
    title: Observable<string>,
    clickHandler?: (item: any, evt: Event) => void,
    extras?: FieldConfigExtras
  ) {
    super('edit', title, 'content:ic_create_24px', 'primary', clickHandler, extras);
  }
}

export class DeleteButtonField extends IconButtonField {
  constructor(
    title: Observable<string>,
    clickHandler?: (item: any, evt: Event) => void,
    extras?: FieldConfigExtras
  ) {
    super('delete', title, 'content:ic_remove_circle_outline_24px', 'warn', clickHandler, extras);
  }
}
